import React, { useEffect, useState } from "react";
import { Over, SimplePlayer } from "../../types/types";
import _ from "underscore";
import MultiSeriesGraph from "../Graphs/MultiSeriesGraph";
import {
  FormControl,
  getTableHeadUtilityClass,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import PlayerDataGrid from "../DataGrid/PlayerDataGrid";
import { BuildOversTable, OversColumns } from "./OversTable";
import { CURRENT_SEASON } from "../../globals/BBLData";
export interface Props {
  overs: Over[];
  aboutplayerid: number;
}
const tooltip = {
  useHTML: true,
  headerFormat: "<table>",
  // pointFormat: `<tr><th colspan="2"><h3>{point.bowler}</h3></th></tr>
  //   <tr><th>Fat intake:</th><td>{point.x}g</td></tr>
  //   <tr><th>Sugar intake:</th><td>{point.y}g</td></tr>
  //   <tr><th>Obesity (adults):</th><td>{point.batter}%</td></tr>`,
  footerFormat: "</table>",
  followPointer: true,
  formatter: function (point, something) {
    return `<tbody><table>
            <tr><th>Runs:</th><td>${this.point.y}</td></tr>
            <tr><th>Bowler:</th><td>${this.point.bowler}</td></tr>
            <tr><th>Bowling Style:</th><td>${this.point.bowlingStyle}</td></tr>
            <tr><th>Batter(s)</th><td>${this.point.batter}</td></tr>
            <tr><th>Bating Style(s)</th><td>${this.point.battingStyle}</td></tr>
        </tbody></table>`;
  },
};

const OversContainer = ({ overs, aboutplayerid }: Props) => {
  const [graphSeries, setGraphSeries] = useState([]);
  const [selectedOvers, setselectedOvers] = useState(overs);
  const [categories, setCategories] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ]);

  const [position, setPosition] = useState("Any");

  useEffect(() => {
    PopulateGraph();
  }, [overs]);
  console.log(
    "OVERS: ",
    overs.filter((o) => o.season === CURRENT_SEASON)
  );
  function PopulateGraph() {
    let newOvers = overs.filter((over) => over.season === CURRENT_SEASON);
    let groupedOvers = _.groupBy(newOvers, function (over) {
      if (over.thegame) {
        return over.thegame.round;
      } else {
        return "unnknown";
      }
    });
    let seriesArr = [];
    //@ts-ignore
    Object.keys(groupedOvers).forEach(function (key, index) {
      let thisdata = [];
      let theovers = {};
      let baseOvers = [];
      for (let i = 0; i < 20; i++) {
        baseOvers.push({
          y: null,
          bowler: "",
          batter: "",
          out: "",
          battingStyle: "",
          bowlingStyle: "",
        });
      }
      //let baseOvers = [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null]
      groupedOvers[key].map(function (over: Over) {
        let include = false;
        if (position !== "Any") {
          if (position === "BWL") {
            //@ts-ignore
            if (over.bowler) {
              if (over.bowler.id === aboutplayerid) {
                include = true;
              }
            }
          } else if (position === "BAT") {
            //@ts-ignore
            if (over.batter) {
              console.log("over: ", over.batter.id, aboutplayerid);

              if (over.batter.id === aboutplayerid) {
                include = true;
              }
            }
          }
        } else {
          include = true;
        }

        console.log("over: ", over, position, include);
        if (include) {
          if (!baseOvers[over.overNumber - 1]["y"]) {
            baseOvers[over.overNumber - 1]["y"] = over.runs;
            baseOvers[over.overNumber - 1]["balls"] = over.balls;
            baseOvers[over.overNumber - 1]["bowler"] = over.bowler
              ? `${over.bowler.firstname[0]} ${over.bowler.lastname}`
              : "";
            baseOvers[over.overNumber - 1]["batter"] = over.batter
              ? `${over.batter.firstname[0]} ${over.batter.lastname}`
              : "";
            baseOvers[over.overNumber - 1][
              "battingStyle"
            ] = `${over.battingStyles}`;
            baseOvers[over.overNumber - 1][
              "bowlingStyle"
            ] = `${over.bowlingStyles}`;
          } else {
            baseOvers[over.overNumber - 1]["y"] =
              baseOvers[over.overNumber - 1]["y"] + over.runs;
            baseOvers[over.overNumber - 1]["balls"] =
              baseOvers[over.overNumber - 1]["balls"] + over.balls;
            if (
              !baseOvers[over.overNumber - 1]["battingStyle"].includes(
                over.battingStyles
              )
            ) {
              baseOvers[over.overNumber - 1]["battingStyle"] =
                baseOvers[over.overNumber - 1]["battingStyle"] +
                `, ${over.battingStyles}`;
            }

            if (
              !baseOvers[over.overNumber - 1]["bowlingStyle"].includes(
                over.bowlingStyles
              )
            ) {
              baseOvers[over.overNumber - 1]["bowlingStyle"] =
                baseOvers[over.overNumber - 1]["bowlingStyle"] +
                `, ${over.bowlingStyles}`;
            }
          }
        }
      });

      seriesArr.push({
        name: `Round - ${key}`,
        data: baseOvers,
        connectNulls: true,
      });
    });
    setGraphSeries(seriesArr);
  }

  function onChange(changeevent: SelectChangeEvent<string>) {
    let newvalues = changeevent.target.value;
    setPosition(newvalues);
  }
  useEffect(() => {
    PopulateGraph();
  }, [position]);
  const overstableRows = BuildOversTable(overs, aboutplayerid);
  return (
    <div style={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}>
      <Paper elevation={5} style={{ width: "100%", padding: "0.25rem" }}>
        <MultiSeriesGraph
          series={graphSeries}
          title="title"
          categories={categories}
          showtitle={"Runs by Overs & Game"}
          type="line"
          tooltip={tooltip}
          baseLabel="Over #"
        />

        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          <FormControl>
            <InputLabel id={`multiinputlabel`} htmlFor={"nativeselectoption"}>
              Position
            </InputLabel>
            <Select
              value={position}
              label={"Position"}
              onChange={(e) => onChange(e)}
              labelId={"multiinputlabel"}
              id="nativeselectoption"
              //style={{width: 250, textAlign: "left", textTransform: 'capitalize'}}
            >
              <MenuItem value={"Any"}>Any</MenuItem>
              <MenuItem value={"BWL"}>Bowling</MenuItem>
              <MenuItem value={"BAT"}>Batting</MenuItem>
            </Select>
          </FormControl>
        </div>
      </Paper>
      <div>
        <PlayerDataGrid
          height={450}
          columns={OversColumns}
          rows={overstableRows}
        />
      </div>
    </div>
  );
};

export default OversContainer;
